// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Gupter:wght@400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contenedor_registro_c{
    display:flex;
    align-items: center; /* Centra horizontalmente */
    justify-content: center; /* Centra verticalmente */
    text-align: center;
}

.preguntas {
    font: 1.4em Gupter;
    display: flex;
    flex-direction: column;
    justify-content: center; /* Centra las columnas horizontalmente */
    align-items: center; /* Centra las filas verticalmente */
    border: double 7px white;
    background-color:#a2d1e0;
    margin-bottom: 20px;
    margin-top: 20px;
    border-radius: 20px;
    padding-top: 20px;
    padding-bottom: 20px;
}

.titulo_c {
    font: 1.8em Gupter;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    color: white;
    background-color: #545454;
    border: double 7px white;
    border-radius: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
}


.etiqueta_c {
    display: flex;
    justify-content: center; /* Centra las columnas horizontalmente */
    align-items: center; /* Centra las filas verticalmente */
    padding: 10px;
    margin: 10px;
}

.etiqueta2 {
    display: flex;
    justify-content: right; /* Centra las columnas horizontalmente */
    align-items: center; /* Centra las filas verticalmente */
    padding: 10px;
    margin: 10px;
    margin-top: 10px;
    margin-bottom: 20px;
}

.casilla {
    justify-content: center; /* Centra las columnas horizontalmente */
    align-items: center; /* Centra las filas verticalmente */
}

.boton_contacto {
    color: white;
    background-color: rgb(8, 95, 182);
}

.centrar {
    display: flex; /* Activa flexbox */
    flex-direction: column;
    justify-content: center; /* Centra horizontalmente */
    align-items: center;
    margin-left: 10px;
}

.error {
    color: red;
    display: block; /* Asegurarse de que se muestre como bloque cuando está presente */
  }
  
  .etiqueta:invalid + .error {
    display: none; /* Ocultar el mensaje si el campo es válido */
  }

.mapa
{   width: 240px;
    height: 320px;
    border-radius: 20px;
    border: double 7px white;
}

button.botonVerificar
{
    margin-top: 20px;
    color: white;
    background-color: rgb(17, 219, 95);;
    padding: 10px;
    margin: 20px;
    border-radius: 20px;
    border: double 7px #a2d1e0;
    font-style: bold;
}

.recaptcha-container {
    display: flex;
    justify-content: center; /* Centra horizontalmente */
    align-items: center; /* Centra verticalmente */
    width: 100%; /* Asegura que el contenedor ocupe todo el ancho disponible */
}
`, "",{"version":3,"sources":["webpack://./src/css/Contacto.css"],"names":[],"mappings":"AAEA;IACI,YAAY;IACZ,mBAAmB,EAAE,2BAA2B;IAChD,uBAAuB,EAAE,yBAAyB;IAClD,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB,EAAE,wCAAwC;IACjE,mBAAmB,EAAE,mCAAmC;IACxD,wBAAwB;IACxB,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;IACzB,wBAAwB;IACxB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;AACxB;;;AAGA;IACI,aAAa;IACb,uBAAuB,EAAE,wCAAwC;IACjE,mBAAmB,EAAE,mCAAmC;IACxD,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB,EAAE,wCAAwC;IAChE,mBAAmB,EAAE,mCAAmC;IACxD,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB,EAAE,wCAAwC;IACjE,mBAAmB,EAAE,mCAAmC;AAC5D;;AAEA;IACI,YAAY;IACZ,iCAAiC;AACrC;;AAEA;IACI,aAAa,EAAE,mBAAmB;IAClC,sBAAsB;IACtB,uBAAuB,EAAE,2BAA2B;IACpD,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,cAAc,EAAE,kEAAkE;EACpF;;EAEA;IACE,aAAa,EAAE,6CAA6C;EAC9D;;AAEF;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;;IAEI,gBAAgB;IAChB,YAAY;IACZ,kCAAkC;IAClC,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB,EAAE,2BAA2B;IACpD,mBAAmB,EAAE,yBAAyB;IAC9C,WAAW,EAAE,6DAA6D;AAC9E","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Gupter:wght@400&display=swap\");\r\n\r\n.contenedor_registro_c{\r\n    display:flex;\r\n    align-items: center; /* Centra horizontalmente */\r\n    justify-content: center; /* Centra verticalmente */\r\n    text-align: center;\r\n}\r\n\r\n.preguntas {\r\n    font: 1.4em Gupter;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center; /* Centra las columnas horizontalmente */\r\n    align-items: center; /* Centra las filas verticalmente */\r\n    border: double 7px white;\r\n    background-color:#a2d1e0;\r\n    margin-bottom: 20px;\r\n    margin-top: 20px;\r\n    border-radius: 20px;\r\n    padding-top: 20px;\r\n    padding-bottom: 20px;\r\n}\r\n\r\n.titulo_c {\r\n    font: 1.8em Gupter;\r\n    display: flex;\r\n    text-align: center;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-weight: bold;\r\n    color: white;\r\n    background-color: #545454;\r\n    border: double 7px white;\r\n    border-radius: 20px;\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n}\r\n\r\n\r\n.etiqueta_c {\r\n    display: flex;\r\n    justify-content: center; /* Centra las columnas horizontalmente */\r\n    align-items: center; /* Centra las filas verticalmente */\r\n    padding: 10px;\r\n    margin: 10px;\r\n}\r\n\r\n.etiqueta2 {\r\n    display: flex;\r\n    justify-content: right; /* Centra las columnas horizontalmente */\r\n    align-items: center; /* Centra las filas verticalmente */\r\n    padding: 10px;\r\n    margin: 10px;\r\n    margin-top: 10px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.casilla {\r\n    justify-content: center; /* Centra las columnas horizontalmente */\r\n    align-items: center; /* Centra las filas verticalmente */\r\n}\r\n\r\n.boton_contacto {\r\n    color: white;\r\n    background-color: rgb(8, 95, 182);\r\n}\r\n\r\n.centrar {\r\n    display: flex; /* Activa flexbox */\r\n    flex-direction: column;\r\n    justify-content: center; /* Centra horizontalmente */\r\n    align-items: center;\r\n    margin-left: 10px;\r\n}\r\n\r\n.error {\r\n    color: red;\r\n    display: block; /* Asegurarse de que se muestre como bloque cuando está presente */\r\n  }\r\n  \r\n  .etiqueta:invalid + .error {\r\n    display: none; /* Ocultar el mensaje si el campo es válido */\r\n  }\r\n\r\n.mapa\r\n{   width: 240px;\r\n    height: 320px;\r\n    border-radius: 20px;\r\n    border: double 7px white;\r\n}\r\n\r\nbutton.botonVerificar\r\n{\r\n    margin-top: 20px;\r\n    color: white;\r\n    background-color: rgb(17, 219, 95);;\r\n    padding: 10px;\r\n    margin: 20px;\r\n    border-radius: 20px;\r\n    border: double 7px #a2d1e0;\r\n    font-style: bold;\r\n}\r\n\r\n.recaptcha-container {\r\n    display: flex;\r\n    justify-content: center; /* Centra horizontalmente */\r\n    align-items: center; /* Centra verticalmente */\r\n    width: 100%; /* Asegura que el contenedor ocupe todo el ancho disponible */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
